import React from 'react';
import $ from 'jquery';
import Language from '../services/Language.js';
import AppModalWidget from './AppModalWidget.js';
import ReactDOM from "react-dom";
import { Html5QrcodeScanType} from "html5-qrcode";
import Html5QrcodePlugin from "./Html5QrcodePlugin";

let inst;

class QRCodeModalWidget extends React.Component {
    constructor(props) {
        super(props);
        if (!inst) {
            this.url = '';
            this.sendedData = {};
            this.modalObject = null;
            this.QRCodeModalWidget = null;

            this.error = false;
            this.el = {
                errors: '.systemModal__body-errors',
                stopScanningButton: '#html5qr-code-full-region__dashboard_section_csr button:last-child',
            };
            this.settings = {};
            this.jsCloseButton = null;

            this.numberOfAttempts = 0;
            this.maxNumberOfAttempts = 10;
            this.result = false;
            inst = this;

            this.cb = null;
        }

        this.showModal = this.showModal.bind(this);
        this.onNewScanResult = this.onNewScanResult.bind(this);

        return inst;
    }

    componentWillUnmount() {
        $(this.el.errors).hide();
    }

    callback() { }

    showModal(cb) {
        this.cb = cb;
        const modalSettings = {};

        this.modalObject = $("<div />", {
            "class": "systemModal"
        });

        this.modalObject.html(`
            <div class="systemModal__header">
                <div class="systemModal__header-title">` + Language.getLabel('L_SCAN_THE_QR_CODE') + `</div>
                <button type="button" class="systemModal__header_button-close" id="jsCloseButton">
                    <svg width="24" height="24" class="icon icon--close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"></path>
                    </svg>
                </button>
            </div>
            <div class="systemModal__body">
                <div id="QRCodeModalWidget" class="QRCodeModalWidget"></div>
                <div class="systemModal__body-errors">
                    <div class="systemModal__body-errors__error">
                        <svg class="icon icon--info" id="icon--info" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.4955 13.1403 13.1403 16.4955 9 16.5ZM3 9.129C3.03549 12.4299 5.73083 15.0822 9.0319 15.0645C12.333 15.0467 14.9997 12.3656 14.9997 9.0645C14.9997 5.76338 12.333 3.08233 9.0319 3.0645C5.73083 3.04684 3.03549 5.69907 3 9V9.129ZM10.5 12.75H8.25V9.75H7.5V8.25H9.75V11.25H10.5V12.75ZM9.75 6.75H8.25V5.25H9.75V6.75Z"></path>
                        </svg>
                        <span>` + Language.getLabel('L_EXCEPTION_UNABLE_TO_SCAN_QR_CODE')  + `</span>
                    </div>
                </div>
            </div>`);

        this.QRCodeModalWidget = this.modalObject.find("#QRCodeModalWidget");

        this.jsCloseButton = this.modalObject.find("#jsCloseButton");
        const handleClick = (e) => {
            e && e.preventDefault();
            this.close();
        };
        this.jsCloseButton.on('click', function() {
            handleClick();
        })

        modalSettings.el = this.modalObject;
        modalSettings.destroyClose = true;

        modalSettings.afterShow = () => {
            this.afterShowHandler();
        };

        AppModalWidget.show(modalSettings);
    }

    onNewScanResult(decodedText, decodedResult) {
        if (decodedResult.decodedText) {
            this.cb(decodedResult.decodedText);
            this.close();
        }
    }

    afterShowHandler() {
        const container = $('#QRCodeModalWidget').get(0);
        this.numberOfAttempts = 0;
        this.error = false;

        if (container) {
            ReactDOM.render(
                <Html5QrcodePlugin
                    fps={2}
                    qrbox={ 140 }
                    disableFlip={false}
                    qrCodeSuccessCallback={this.onNewScanResult}
                    supportedScanTypes={Html5QrcodeScanType.SCAN_TYPE_CAMERA}
                />,
                container,
                () => {
                    const jsErrors = $(this.el.errors);
                    const handleClose = () => {
                        this.close();
                    };
                    /*setTimeout(function() {
                        jsErrors.show();
                        setTimeout(function() {
                            handleClose();

                        }, 2000);
                    }, 10000);*/

                }
            );
        }
    }

    recentAnimation() { }

    close() {
        $(this.el.stopScanningButton).click();

        if (this.modalObject) {
            AppModalWidget.close(() => {});
        }
    }
}

export default new QRCodeModalWidget();
